import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { navContextSearchSchema } from '~/features/catalog-enrichment/utils/nav-context';

const ExperimentDetailPage = lazy(
  () => import('~/features/catalog-enrichment/pages/experiment-detail-page'),
);

/** Active detail tab, kept in the URL so Back returns to it; `from`/`back` (S8) carry where a
 *  cross-section link (a batch's experiment chip…) sent the user here. */
const experimentDetailSearchSchema = z.object({
  tab: z.enum(['overview', 'arms', 'samples', 'batches', 'config']).optional().catch(undefined),
  ...navContextSearchSchema,
});

export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/experiments/$experimentId',
)({
  validateSearch: experimentDetailSearchSchema,
  component: RouteComponent,
});

/** Keyed by id: opening another experiment remounts the page, so tab filters / pagers reset. */
function RouteComponent() {
  const { experimentId } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ExperimentDetailPage key={experimentId} experimentId={experimentId} />
    </Suspense>
  );
}
